export function PlaceholderNodeBody({ children }) {
  return (
    <div className='cursor-default bg-neutral01 border border-dashed border-neutral03 rounded p-2 flex gap-4 items-center hover:border-neutral05'>
      {children}
    </div>
  )
}
